import Navigation from "@/components/Navigation";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
        
        <div className="prose prose-lg max-w-none space-y-6">
          <section>
            <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
            <p className="text-muted-foreground">
              By accessing and using this course platform, you accept and agree to be bound by the terms and provision of this agreement.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">2. Course Access</h2>
            <p className="text-muted-foreground">
              Upon successful payment, you will receive lifetime access to the course materials. Access is personal and non-transferable.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">3. Payment and Refunds</h2>
            <p className="text-muted-foreground">
              All payments are processed securely through Stripe. All sales are final and we do not offer refunds.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">4. User Conduct</h2>
            <p className="text-muted-foreground">
              You agree not to share your account credentials, redistribute course materials, or use the platform in any way that violates applicable laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">5. Intellectual Property</h2>
            <p className="text-muted-foreground">
              All course content, including videos, documents, and materials, are protected by copyright and are the property of the course creator.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">6. Modifications</h2>
            <p className="text-muted-foreground">
              We reserve the right to modify these terms at any time. Continued use of the platform constitutes acceptance of modified terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">7. Contact</h2>
            <p className="text-muted-foreground">
              For questions about these terms, please contact us through our support system.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;
